import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGoogleDrive } from "@fortawesome/free-brands-svg-icons";
import "../styles/downloadStyles.css";
import ProductsData from "../data/products.json";
import pdfIcon from "../assets/icons/pdf.png";

const Downloads = () => {
  const [activeCategory, setActiveCategory] = useState("Datasheets");

  const CATEGORY_MAP = {
    Datasheets: "Datasheet",
    "Connection Diagrams": "Connection Diagram",
    "User Manuals": "User Manual",
  };

  const handleCategoryChange = (event) => {
    setActiveCategory(event.target.value);
  };

  const renderFiles = () => {
    const normalizedCategory = CATEGORY_MAP[activeCategory];
    if (!normalizedCategory) return null;

    const filteredProducts = ProductsData.products.map((product) => {
      const matchingItems = product.subCategories.flatMap((subCategory) =>
        subCategory.products
          .filter((item) =>
            item.files?.some(
              (file) =>
                file[normalizedCategory] && file[normalizedCategory].link
            )
          )
          .map((item) => ({
            ...item,
            subCategoryName: subCategory.subCategoryName,
          }))
      );

      return { ...product, matchingItems };
    });

    return filteredProducts.map(
      (product, index) =>
        product.matchingItems.length > 0 && (
          <div key={index} className="row mb-5">
            <h3 className="text-center mb-4">{product.categoryName}</h3>
            <div className="table-responsive">
              <table
                className="table table-bordered"
                style={{
                  border: "2px solid #000",
                  borderCollapse: "collapse",
                  tableLayout: "fixed",
                  width: "100%",
                }}
              >
                <thead className="thead-dark">
                  <tr>
                    <th
                      className="text-center d-none d-sm-table-cell"
                      style={{ width: "20%" }}
                    >
                      File Type
                    </th>
                    <th className="text-center" style={{ width: "30%" }}>
                      Product Name
                    </th>
                    <th
                      className="text-center d-none d-sm-table-cell"
                      style={{ width: "30%" }}
                    >
                      Subcategory Name
                    </th>
                    <th className="text-center" style={{ width: "20%" }}>
                      Download PDF
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {product.matchingItems.map((item, idx) => (
                    <tr key={idx} className="text-center">
                      <td className="d-none d-sm-table-cell">
                        <img
                          src={pdfIcon}
                          alt="PDF Icon"
                          style={{ width: "40px", height: "auto" }}
                        />
                      </td>
                      <td>{item.productName}</td>
                      <td className="d-none d-sm-table-cell">
                        {item.subCategoryName}
                      </td>
                      <td>
                        {item.files
                          .filter(
                            (file) =>
                              file[normalizedCategory] &&
                              file[normalizedCategory].link
                          )
                          .map((file, fileIdx) => (
                            <a
                              key={fileIdx}
                              href={file[normalizedCategory].link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-outline-dark mx-1"
                            >
                              {normalizedCategory}
                            </a>
                          ))}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )
    );
  };

  return (
    <div className="container my-5">
      <div className="w-full nav-height">
        <section className="mb-5">
          <h2 className="text-center mb-4">Downloads</h2>
          <div className="row">
            {[
              {
                name: "iDMS",
                link: "https://drive.google.com/file/d/1Lcg4OarCVFsJ_Kvra3C4IjhPH0J_-EKd/view?usp=sharing",
              },
              {
                name: "iAS",
                link: "https://drive.google.com/file/d/1OCLCQtvVzGjX52hVaXsTsh6CnSyFmCTa/view?usp=sharing",
              },
              {
                name: "TimeWatch Access Control",
                link: "https://drive.google.com/file/d/12d-6KEwjnd-_vQJu-kgnXJ0iujodZA1j/view?usp=share_link",
              },
              {
                name: "TimeWatch Access Contol SDK",
                link: "https://drive.google.com/file/d/1OpfTXM_vAwetewHxIAH6D8tXHpQDbLhy/view?usp=sharing",
              },
              {
                name: "TrueFace SDK",
                link: "https://drive.google.com/file/d/1sjntsUBbB2mVTcRZWDkpY6Ziw_niCbaa/view?usp=drive_link",
              },
              {
                name: "Tams9.5",
                link: "https://drive.google.com/file/d/1Kcuqm9mMSI_XvLN1ZBcrNQZ81QG1fsFo/view?usp=share_link",
              },
              {
                name: "TimeWatch Catalogue",
                link: "https://timewatch.co.in/docs/TimeWatchCatalogue.pdf",
              },
              
            ].map((sdk, index) => (
              <div className="col-12 col-sm-6 col-md-4 mb-4" key={index}>
                <a
                  href={sdk.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn w-100 d-flex flex-column align-items-center justify-content-center border border-danger text-danger"
                  style={{
                    height: "150px",
                    transition: "0.3s",
                    cursor: "pointer",
                  }}
                >
                  <FontAwesomeIcon icon={faGoogleDrive} size="3x" />
                  <span className="mt-2">{sdk.name}</span>
                </a>
              </div>
            ))}
          </div>
        </section>
        <section className="mb-5">
          <h2 className="text-center mb-4" style={{ fontWeight: "bold" }}>
            {activeCategory}
          </h2>
          <div className="row mb-4">
            <div className="col-12 col-md-3">
              <select
                className="form-select"
                value={activeCategory}
                onChange={handleCategoryChange}
                style={{
                  fontSize: "1.2rem",
                  padding: "10px",
                  border: "1px solid #000",
                  borderRadius: "10px",
                }}
              >
                {Object.keys(CATEGORY_MAP).map((category) => (
                  <option key={category} value={category}>
                    {category}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {renderFiles()}
        </section>
      </div>
    </div>
  );
};

export default Downloads;
